import * as React from "react";
import moment from "moment";
import { Column } from "primereact/column";
import { Modal, ModalHeader, ModalBody, ModalFooter, Row, Col, Button } from "reactstrap";
import { Link } from "react-router-dom";
import PageLayout from "../../components/PageLayout";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import useEntitiesList from "../../utils/listHookNew";
import { DataTable } from "primereact/datatable";
import { useAuth0 } from "../../auth/react-auth0-wrapper";
import roles from "../../auth/roles";
import { renderHeader, DropdownFilterElement, filterDateTime, getDateTime, filterDate, getDate } from "../../components/TableUtils";
import Can from "../../auth/Can";
import classNames from 'classnames';
import { deleteDraft } from "../../api/collaudo";

export default function CollaudoList() {
    const { user } = useAuth0();
    let dtable;

    const [result, loading, setLoading, globalFilter, setGlobalFilter, forceRefresh] = useEntitiesList("collaudo", "createdat desc", user.isInRole([roles.ADMIN]) ? undefined : `createdby='${user.email}'`, "")

    const [openModal, setOpenModal] = React.useState(false);
    const toggle = () => setOpenModal(!openModal);

    const onDelete = async id => {
        try {
            setLoading(true)
            await deleteDraft(id);
        } finally {
            toggle();
            setLoading(false)
            forceRefresh();
            return;
        }
    };

    const modalSection = () => (
        <Modal zIndex={2000} centered size="sm" isOpen={openModal ? true : false} backdrop={true}>
            <ModalHeader toggle={toggle}>
                Eliminazione Collaudo
            </ModalHeader>
            <ModalBody>
                <p>Confermi di voler eliminare il Collaudo del veicolo?</p>
            </ModalBody>
            <ModalFooter>
                <Button color="link" className="btn-link-dark" onClick={toggle}>Annulla</Button>{' '}
                <Button color="danger" className="ml-auto" onClick={() => onDelete(openModal._id)}>Elimina</Button>
            </ModalFooter>
        </Modal>
    );

    const getHeader = () => {
        return (
            <Can
                roles={[roles.ADMIN, roles.CENTRALE]}
                yes={() => (
                    <div className="action-container">
                        <Link
                            title="Aggiungi Collaudo"
                            className="btn btn-primary p-button-icon-only"
                            to={`/collaudo/start-collaudo`}
                        >
                            <i className="pi pi-plus mr-2"></i>Nuovo Collaudo
                        </Link>
                    </div>
                )}
                no={() => null}
            />
        );
    };

    const onRefresh = () => {
        forceRefresh();
        setGlobalFilter("");
    }

    const exportTable = () => {
        dtable.exportCSV();
    }

    return (
        <PageLayout title="Elenco Collaudi">
            <Row>
                <Col>
                    <DataTable
                        ref={el => {
                            dtable = el;
                        }}
                        loading={loading}
                        value={result}
                        rowsPerPageOptions={[5, 10, 20, 50, 100]}
                        className="p-datatable-hoverable-rows p-datatable-customers"
                        responsive
                        paginator={true}
                        autoLayout={false}
                        first={0}
                        rows={20}
                        totalRecords={result.length}
                        paginatorPosition="both"
                        header={renderHeader(loading, result.length, undefined, getHeader(), { globalFilter, setGlobalFilter, onRefresh }, exportTable)}
                        globalFilter={globalFilter}
                        emptyMessage={() => (<div className="text-center">Nessun collaudo in tabella</div>)}
                        paginatorTemplate="RowsPerPageDropdown CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink"
                        currentPageReportTemplate="Visualizzati {first} di {last} Collaudi su un totale di {totalRecords}"
                    >
                        <Column
                            field="attributes.customer_name"
                            header="Cliente"
                            sortable
                            filter
                            filterMatchMode="contains"
                            style={{ wordWrap: "break-word" }}
                            body={(rowData, column) => {
                                return (
                                    <Link
                                        to={`/collaudo/test-dashboard/${rowData._id}`}
                                    >
                                        {rowData.attributes.customer_name}
                                    </Link>
                                );
                            }}
                        />
                        <Column
                            field="attributes.tenant_name"
                            header="Dealer"
                            sortable
                            filter
                            filterMatchMode="contains"
                            style={{ wordWrap: "break-word" }}
                        />
                        <Column
                            field="attributes.imei"
                            header="IMEI"
                            sortable
                            filter
                            filterMatchMode="contains"
                            style={{ wordWrap: "break-word" }}
                        />
                        <Column
                            field="attributes.number"
                            header="Telefono"
                            sortable
                            filter
                            filterMatchMode="contains"
                            style={{ wordWrap: "break-word" }}
                        />
                        <Column
                            field="attributes.serial"
                            header="Seriale"
                            sortable
                            filter
                            filterMatchMode="contains"
                            style={{ wordWrap: "break-word" }}
                        />
                        <Column
                            field="attributes.plate"
                            style={{ wordWrap: "break-word" }}
                            header="Targa"
                            sortable
                            filter
                            filterMatchMode="contains"
                            body={(rowData, column) => {
                                return (
                                    <Link
                                        to={`/tenant/vehicles/${rowData.vehicle_id}`}
                                    >
                                        {rowData.attributes.plate.toUpperCase()}
                                    </Link>
                                );
                            }}
                        />
                        <Column
                            field="createdat"
                            header="Inserito il"
                            sortable
                            filter
                            filterMatchMode="custom"
                            filterFunction={filterDateTime}
                            body={getDateTime}
                            style={{ wordWrap: "break-word" }}
                        />
                        <Column
                            field="collaudodat"
                            header="Data collaudo"
                            sortable
                            filter
                            filterMatchMode="custom"
                            filterFunction={filterDate}
                            body={getDate}
                            style={{ wordWrap: "break-word" }}
                        />
                        <Column
                            field="createdby"
                            header="Operatore"
                            sortable={user.isInRole([roles.ADMIN])}
                            filter={user.isInRole([roles.ADMIN]) ? true : false}
                            filterMatchMode="contains"
                            style={{ wordWrap: "break-word" }}
                        />
                        <Column
                            field="status"
                            header="Stato"
                            sortable
                            filter
                            style={{ wordWrap: "break-word" }}
                            filterElement={
                                <DropdownFilterElement
                                    field="status"
                                    options={[
                                        { label: "inserito", value: "inserito" },
                                        { label: "firmato", value: "firmato" },
                                        { label: "da firmare", value: "giscomplete" }
                                    ]}
                                    onChange={e => dtable.filter(e.value, e.field)}
                                />
                            }
                            style={{ wordWrap: "break-word", textAlign: "center" }}
                            body={(rowData, column) => {
                                return (
                                    <span className={classNames('customer-badge', 'status-' + rowData.status)}>{rowData.status !== 'giscomplete' ? rowData.status : 'da firmare'}</span>
                                );
                            }}
                        />
                        <Column
                            field="actions"
                            body={(rowData, column) => {
                                return (
                                    <div className="action-container">
                                        <Link
                                            title="Gestisci collaudo"
                                            className="btn btn-sm btn-primary p-button-icon-only"
                                            to={`/collaudo/test-dashboard/${rowData._id}`}
                                        >
                                            <i className="pi pi-pencil"></i>
                                        </Link>

                                        {rowData.status === "inserito" &&
                                            <Can
                                                roles={[roles.ADMIN]}
                                                yes={() => (
                                                    <Button
                                                        title="Elimina collaudo"
                                                        color="danger"
                                                        onClick={() => setOpenModal(rowData)}
                                                        className="btn-sm"
                                                    >
                                                        <FontAwesomeIcon icon="trash-alt" />
                                                    </Button>
                                                )}
                                                no={() => null}
                                            />
                                        }
                                    </div>
                                );
                            }}
                            style={{ wordWrap: "break-word" }}
                        />
                    </DataTable>
                </Col>
            </Row>
            {modalSection()}
        </PageLayout>
    );
}
